module.exports = __webpack_public_path__ + "media/images/expert-slide4-27a1760bc8cf5113158597b0a5418c8c10a762754060f13b48ea084d508bfd19.jpg";